import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { MadAuthService } from "../../mad-auth/mad-auth.service";
import { SubdomainService } from "../../_base/subdomain.service";
import { APIPaginatedResponse, APIResponse } from "../types/api-response";
import { RentBasis, RentBasisListing } from "../types/rent-basis";
import { environment } from "src/environments/environment";
import { map } from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class RentBasisService {
  constructor(
    private http: HttpClient,
    private authService: MadAuthService,
    private subDomainService: SubdomainService
  ) {}

  fetchListing() {
    return this.http.get<APIResponse<RentBasisListing>>(
      environment.baseApiUrl + `api/v2/${this.subDomainService.subDomain}/rent-bases/listing`,
      {
        headers: this.authService.getAuthHeaders()
      }
    ).pipe(
      map(response => response.data)
    )
  }

  fetch() {
    return this.http.get<APIPaginatedResponse<RentBasis>>(
      environment.baseApiUrl + `api/v2/${this.subDomainService.subDomain}/rent-bases`,
      {
        headers: this.authService.getAuthHeaders()
      }
    )
  }

  create(payload: RentBasis) {
    return this.http.post<unknown>(
      environment.baseApiUrl + `api/v2/${this.subDomainService.subDomain}/rent-bases`,
      payload,
      {
        headers: this.authService.getAuthHeaders()
      }
    )
  }

  update(id: number, payload: RentBasis) {
    return this.http.put<unknown>(
      environment.baseApiUrl + `api/v2/${this.subDomainService.subDomain}/rent-bases/${id}`,
      payload,
      {
        headers: this.authService.getAuthHeaders()
      }
    )
  }

  get(id: number) {
    return this.http.get<{data: RentBasis}>(
      environment.baseApiUrl + `api/v2/${this.subDomainService.subDomain}/rent-bases/${id}`,
      {
        headers: this.authService.getAuthHeaders()
      }
    )
  }
  
  delete(id: number) {
    return this.http.delete<unknown>(
      environment.baseApiUrl + `api/v2/${this.subDomainService.subDomain}/rent-bases/${id}`,
      {
        headers: this.authService.getAuthHeaders()
      }
    )
  }

  trashed() {
    return this.http.get<{data: RentBasis[]}>(
      environment.baseApiUrl + `api/v2/${this.subDomainService.subDomain}/rent-bases/trashed`,
      {
        headers: this.authService.getAuthHeaders()
      }
    )
  }

  adminTrashed() {
    return this.http.get<{data: RentBasis[]}>(
      environment.baseApiUrl + `api/v2/${this.subDomainService.subDomain}/rent-bases/admin-trashed`,
      {
        headers: this.authService.getAuthHeaders()
      }
    )
  }
}